import React from "react";
import { useNavigate } from "react-router-dom";
const PackagesTabContent = (props) => {
  const { item } = props;

  const navigate = useNavigate();

  return (
    <div className="owl-item col-lg-4 col-md-6 col-sm-12 my-3 cloned">
      <div className="item h-100">
        <div className="myCard2 h-100">
          <p
            className="font-32 font-w800"
            // style={{
            //   maxWidth: "80%",
            // }}
          >
            {item.title}
          </p>
          <p className="font-13 text-grey contentScroll contentScroll-upper">
            {item.overview}
          </p>
          <div className="d-inline-flex align-items-center">
            <span className="font-45 font-w800 border-right text-center line-height-45 pr-2 mr-2">
              ${item.offerPrice}
            </span>
            &nbsp; &nbsp;
            <span className="text-dec-line-thro text-red font-24">
              ${item.actualPrice}
            </span>
          </div>
          <div className="contentScroll">
            {item.featuresList.map((feature, index) => (
              <p className="dot-before" key={index}>
                {feature.feature}
              </p>
            ))}
          </div>

          <div className="row bot-links mb-3">
            {item.viewDetailsBtn && (
              <div className="col-xl-6">
                <button className="btn btn-order m-0 px-3 w-100 view-detail ">
                  VIEW DETAILS
                </button>
              </div>
            )}

            {item.orderNowBtn && (
              <div className="col-xl-6">
                <a
                  className="btn btn-order m-0 px-2 w-100"
                  onClick={() => {
                    if (item?.OrderUrl) {
                      navigate(`${item?.OrderUrl}`);
                    }
                  }}
                >
                  Order Now &nbsp; <i className="fa fa-arrow-right pl-3"></i>
                </a>
              </div>
            )}
          </div>

          <div className="row bot-links">
            {item.CTACall && (
              <div className="col-xl-6 border-right text-center">
                <div className="text-yellow">Share your idea?</div>
                <a className="mob" href={item.CTACall}>
                  +971 58 176 5760
                </a>
              </div>
            )}
            {item.CTAChat && (
              <div className="col-xl-6 pl-xl-4 text-center">
                <div className="text-yellow">Want to Discuss?</div>
                <a
                  href={item.CTAChat}
                  className="chat_wrap liveChat text-center"
                >
                  Live Chat Now
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackagesTabContent;
